const HOTKEYS = {};
export default HOTKEYS;
